/**
 * Các key của tiến trình chạy
 */
export default {
  CloseLedger: 'CloseLedger',
};